// extracted by mini-css-extract-plugin
export default {"tabs":"CasinoTabs_tabs__WKmZV","tab":"CasinoTabs_tab__thJKK","active":"CasinoTabs_active__ti3Ue"};